var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16116 0.583008C1.91183 0.583008 0.0883789 2.37883 0.0883789 4.59408V17.9643C0.0883789 20.1796 1.91183 21.9754 4.16116 21.9754H23.1675C25.4168 21.9754 27.2403 20.1796 27.2403 17.9643V4.59408C27.2403 2.37883 25.4168 0.583008 23.1675 0.583008H4.16116ZM3.92428 3.27734C4.0012 3.26401 4.08036 3.25706 4.16116 3.25706H23.1675C23.2483 3.25706 23.3275 3.26401 23.4044 3.27734L13.6643 9.67233L3.92428 3.27734ZM2.80357 5.75532V17.9643C2.80357 18.7027 3.41138 19.3013 4.16116 19.3013H23.1675C23.9173 19.3013 24.5251 18.7027 24.5251 17.9643V5.75535L14.4174 12.3917C13.9614 12.6911 13.3673 12.6911 12.9113 12.3917L2.80357 5.75532Z",
    fill: "#34368A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.84b987db4ad388d9a8feaa79b13fc6ab.svg";
export { ForwardRef as ReactComponent };